/**
 * Created by hj on 2017/9/4.
 */
import {config, request} from 'Utils';

/**
 * 购货单位查询
 * @param param
 * @returns {*}
 */
export function buy(param) {
    // return request(`${config.server}/api/v1/dms/tzOrderSync/invoiceSalesUnitList`, {
    return request(`${config.server}/api/v1/dms/dmsPurchase/list`, {
        method: 'post',
        body: param
    });
}

/**
 * 购货单位查询
 * 开票管理所需的购货单位
 * @channelCode // 渠道code
 */
export function newPurchaseUnit(channelCode) {
    // return request(`${config.server}/api/v1/dms/tzOrderSync/invoiceSalesUnitList`, {
    return request(`${config.server}/api/v1/dms/tzOrderTraceHeadBack/purchase?channelCode=${channelCode}`, {
        method: 'get'
    });
}


/**
 * 获取开票详情 get
 * @param param
 * @returns {*}
 */
export function getDetail1(ID) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/invoiceDetailHead?id=${ID}`, {
        method: 'get'
    });
}

/**
 * 暂存单点击下一步 get
 * @param param {
    salesUnitId： 购货单位id
    salesChannelCode：渠道code
    ids 暂存单Ids[]
 * }
 * @returns {*}
 */
export function goNext(param) {
    // return request(`${config.server}/api/v1/dms/tzOrderSync/nextNormalSpecialInvoice`, {
    return request(`${config.server}/api/v1/dms/tzOrderSync/nextInvoiceInfo`, {
        // method: 'get'
        method: 'post',
        body: param
    });
}

/*正常特殊开票列表*/
export function getProductList(param) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/invoicelist`, {
        method: 'post',
        body: param
    });
}


/*开票暂存单列表*/
export function getProductList2(param) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/invoiceStagingList`, {
        method: 'post',
        body: param
    });
}

/*正常开票管理*/
export function getProductList3(ID, p, s) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/invoiceDetailTable?id=${ID}&p=${p}&s=${s}`, {
        method: 'get',
    });
}

/*开票列表*/
export function getProductList4(param) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/list`, {
        method: 'post',
        body: param
    });
}

/* 暂存单条数&总金额 */
export function invoiceTempTotalAmount(param) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/invoiceTempTotalAmount`, {
        method: 'get'
    });
}

/* 删除开票信息 */
export function deleteInvoice(id) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/deleteInvoice?id=${id}`, {
        method: 'get'
    });
}

/*开票申请前页列表*/
export function getProductList5(param) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/invoiceSummaryList`, {
        method: 'post',
        body: param
    });
}

/*开票申请列表*/
export function getProductList6(param) {
    return request(`${config.server}/api/v1/dms/dmsPurchase/list`, {
        method: 'post',
        body: param
    });
}

/* 指定金额开票
   params {
    totalAmount //总金额
    salesUnitId //购货单位Id
    salesChannelCode // 渠道编码
   }
*/
export function amountInvoiceDetail(param) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/amountInvoiceDetail`, {
        method: 'post',
        body: param
    });
}

/*正常开票*/
export function getProductList7(param) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/nextNormalSpecialInvoice`, {
        method: 'get',
    });
}

/*特殊开票*/
export function getProductList8(param) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/list`, {
        method: 'post',
        body: param
    });
}

/**
 * 按规格查询产品列表
 * @param param
 * @returns {*}
 */
export function getlistPcSpec(param) {
    /*
     param: {
     kw:''
     p:1,
     s:10
     }
    * */
    return request(`${config.server}/api/v1/dms/product/listPcSpec`, {
        method: 'post',
        body: param
    });
}


/**
 * 删除按钮
 * @param param
 * @returns {*}
 */
export function setProductUp(param) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/delInvoiceStaging`, {
        method: 'post',
        body: param
    });
}

/**
 * 删除按钮
 * @param param
 * @returns {*}
 */
export function setProductUp1(param) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/invoiceDetailList`, {
        method: 'post',
        body: param
    });
}

/**
 * 详情页确认签收(废弃)
 * @param param
 * @returns {*}
 */
export function setProductUp2(param) {
    return request(`${config.server}/api/v1/dms/product/up`, {
        method: 'post',
        body: param
    });
}

/**
 * 详情页确认签收
 * @param param {
 *    id
 * }
 * @returns {*}
 */
export function confirmReceive(id) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/confirmReceive?headId=${id}`, {
        method: 'get'
    });
}

/**
 * 加到暂存单
 * @param param
 * @returns {*}
 */
export function setProductUp3(param) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/addInvoiceStaging`, {
        method: 'post',
        body: param
    });
}

/**
 * 加到追溯行到暂存单
 * @param param
 * @returns {*}
 */
export function addTrace(param) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/addInvoiceTraceStaging`, {
        method: 'post',
        body: param
    });
}

/**
 * 加到暂存单
 * @param param
 * @returns {*}
 */
export function textZan(param) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/checkInvoiceStaging?salesUnitId=${param}`, {
        method: 'get',
    });
}


/**
 * 修改暂存单1
 * @param param
 * @returns {*}
 */
export function setProductUp4(id, qty, taxCode, price) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/updateInvoiceStaging?id=${id}&qty=${qty}&taxCode=${taxCode}&price=${price}`, {
        method: 'get',
    });
}

/**
 * 修改暂存单2
 * @param param
 * @returns {*}
 */
export function setProductUp5(id, remark, taxCode, price) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/updateInvoiceStaging?id=${id}&remark=${remark}&taxCode=${taxCode}&price=${price}`, {
        method: 'get',
    });
}


/**
 * 产品 批量下架
 * @param param
 * @returns {*}
 */
export function setProductDown(param) {
    return request(`${config.server}/api/v1/dms/product/down`, {
        method: 'post',
        body: param
    });
}

/**
 * 产品详情 get
 * @param param
 * @returns {*}
 */
export function getProductDetails(id) {
    return request(`${config.server}/api/v1/dms/product/details?id=` + id);
}

/**
 * 产品 新建
 * @param param
 * @returns {*}
 */
export function saveProductAdd(param) {
    return request(`${config.server}/api/v1/dms/product/create`, {
        method: 'post',
        body: param
    });
}

/**
 * 产品 编辑
 * @param param
 * @returns {*}
 */
export function saveProductEdit(param) {
    return request(`${config.server}/api/v1/dms/product/update`, {
        method: 'post',
        body: param
    });
}

/**
 * 产品规格
 * @param param
 * @returns {*}
 */
export function getProductSpec(productTypeId) {
    return request(`${config.server}/api/v1/dms/spec/specList`, {
        method: 'post',
        body: {
            active: 1,
            productTypeId: productTypeId
        }
    });
}

/**
 * 产品分类 get
 * @param param
 * @returns {*}
 */
export function getProductCategory() {
    return request(`${config.server}/api/v1/dms/category/listTree`, {
        method: 'get'
    });
}

/**
 * 产品品牌 get
 * @param param
 * @returns {*}
 */
export function getProductBrand() {
    return request(`${config.server}/api/v1/dms/productBrand/list`, {
        method: 'post',
        body: {
            p: 1,
            s: 1000000,
            active: 1
        }
    });
}

/**
 * 数据字典 get
 * @param param
 * @returns {*}
 */
export function getDictionay(key) {
    return request(`${config.server}/api/v1/dms/dictionayDependent/sKeylist?sKey=${key}`, {
        method: 'get'
    });
}

/**
 * 获取产品评论列表 get
 * @param param
 * @returns {*}
 */
export function getProductComment(productId) {
    return request(`${config.server}/api/v1/dms/product/getProductEevaluation?productId=${productId}`, {
        method: 'get'
    });
}

/**
 * 统计评论数量 get
 * @param param
 * @returns {*}
 */
export function getProductCommentCount(productId) {
    return request(`${config.server}/api/v1/dms/product/getProductEevaluationCount?productId=${productId}`, {
        method: 'get'
    });
}

/**
 * 获取产品规格的库存与价格 post
 * @param param
 * @returns {*}
 */
export function refreshPriceStockFn(params) {
    return request(`${config.server}/api/v1/dms/product/specInventory`, {
        method: 'post',
        body: params
    });
}

/**
 * 判断规格组合是否可以删除 post
 * @param param
 * @returns {*}
 */
export function getMatrixForDelete(id) {
    return request(`${config.server}/api/v1/dms/product/detailsSpecMatrix?id=${id}`, {
        method: 'get'
    });
}

/**
 * 查询组织树 包含渠道\区域\门店
 * @param param
 * @returns {*}
 */
export function getOrgTree() {
    return request(`${config.server}/api/v1/dms/treeRelation/tgTreeyarn`, {
        method: 'get'
    });
}

/**
 * 查询组织树 包含渠道\区域\门店
 * @param param
 * @returns {*}
 */
export function getEditData(id) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/invoiceDetail?id=${id}`, {
        method: 'get'
    });
}

/*
 * 签收状态查询
 * @param param
 * @returns {*}
 
export function getSignStatus () {
  return request(`${config.server}/api/v1/dms/tzOrderSync/getSignStatus`, {
    method: 'get'
  });
}*/

/**
 * 正常开票头信息 post
 * @param param
 * @returns {*}
 */
export function getHead(params) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/normalSpecialHeadInvoice`, {
        method: 'post',
        body: params
    });
}

/**
 * 正常开票列表信息 post
 * @param param
 * @returns {*}
 */
export function getBodyList(params) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/normalSpecialLineInvoice`, {
        method: 'post',
        body: params
    });
}

/**
 * 正常开票购销单位信息 post
 * @param param
 * @returns {*}
 */
export function getGouXiao(params) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/getGouXiaoUnit`, {
        method: 'post',
        body: params
    });
}

/**
 * 正常开票邮寄地址 post
 * @param param
 * @returns {*}
 */
export function getYouJi(params) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/getCusEmailAddress`, {
        method: 'post',
        body: params
    });
}

/**
 * 正常开票提交 post
 * @param param
 * @returns {*}
 */
export function giveNormal(params) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/submitNormalSpecialInvoice`, {
        method: 'post',
        body: params
    });
}

/**
 * 修改特殊开票说明调整
 * @param param
 * @returns {*}
 */
export function changeText(params) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/updateSpecialLineInvoice`, {
        method: 'post',
        body: params
    });
}

/**
 * 直接开票
 * @param param
 * invoiceVos: [{
 *   deliveryId,  // 出库编号
 *   orderNumber, // 订单编号
 *   itemNum  // 物料编码
 * }]
 */
export function directInvoiceInfo(params) {
    return request(`${config.server}/api/v1/dms/tzOrderSync/directInvoiceInfo`, {
        method: 'post',
        body: params
    });
}

export function getSaleInvoiceBank() {
    return request(`${config.server}/api/v1/dms/tzOrderSync/getSaleInvoiceBank`, {
        method: 'get'
    });
}

export function getSalesUnitApproveList(skey) {
    return request(`${config.server}/api/v1/dms/dictionayDependent/sKeylist?sKey=${skey}`, {
        method: 'get'
    });
}

/*Excel导出*/
export const exportFun = `${config.server}/api/v1/dms/storageBill/exportBill`;


// WEBPACK FOOTER //
// ./src/service/invoiceManagement/index.js